
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'submitButton': {'marginTop': `16px`,},'sq-fieldset': {'backgroundColor': `#f7f7f7`,},'squareInputStyles': {'backgroundColor': `transparent`,'color': `#000000`,'fontSize': `16px`,'lineHeight': `24px`,'padding': `16px`,},'formContainer': {'margin': `20px 0`,},
        
      };
    };
  